import Image from './image'

export default Image
